import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../../infrastructure/content';
import PropTypes from '../../../../types';
import {
  PERSONAL_ADDRESS_TYPE,
  REGISTER_ADDRESS_TYPE,
  TRADING_ADDRESS_TYPE,
  DIFFERENT_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE
} from '../../../../utils/constants';

const required = (value) => (value ? undefined : 'Required');

const MultipleAddressMailing = ({ isSoleTrader, onAddressSelection, selectedAddressId }) => (
  <Content>
    {({
      mailingAddress,
      sameAsPersonalAddress = '',
      sameAsRegisteredAddress = '',
      enterDifferentAddress = '',
      sameAsTradingAddress = '',
      mailingAddressError = '',
      mailingAddressSupplementHelpText = ''
    }) => (
      <Field name="mutipleAddressMailing" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="mutipleAddressMailing"
            hasError={touched && !!error}
            description={mailingAddressSupplementHelpText}
            title={mailingAddress}
            validationMessage={touched && !!error ? mailingAddressError : ''}
          >
            <Field name="mutipleAddressMailing" validate={required}>
              {({ input }) => (
                <GenericRadio.StackedSet
                  groupName="mutipleAddressMailing"
                  selectedId={selectedAddressId}
                  items={
                    !isSoleTrader
                      ? [
                          {
                            id: PERSONAL_ADDRESS_TYPE,
                            labelText: sameAsPersonalAddress
                          },
                          {
                            id: REGISTER_ADDRESS_TYPE,
                            labelText: sameAsRegisteredAddress
                          },
                          {
                            id: TRADING_ADDRESS_TYPE,
                            labelText: sameAsTradingAddress
                          },
                          {
                            id: DIFFERENT_ADDRESS_TYPE,
                            labelText: enterDifferentAddress
                          }
                        ]
                      : [
                          {
                            id: PERSONAL_ADDRESS_TYPE,
                            labelText: sameAsPersonalAddress
                          },
                          {
                            id: TRADING_ADDRESS_TYPE,
                            labelText: sameAsRegisteredAddress
                          },
                          {
                            id: DIFFERENT_ADDRESS_TYPE,
                            labelText: enterDifferentAddress
                          }
                        ]
                  }
                  onChange={(selectedId) => {
                    onAddressSelection(MAILING_ADDRESS_TYPE, selectedId);
                    input.onChange(selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

MultipleAddressMailing.propTypes = {
  isSoleTrader: PropTypes.bool
};

export default MultipleAddressMailing;
